import { gql, useQuery } from '@apollo/client';
import { InvestmentEntityType } from '__generated__/graphql';
import { useNavigate } from 'react-router-dom';
import { InvestmentEntityCard } from 'routes/Invest/InvestmentEntities';

import SidebarLayout, {
  SidebarLayoutContent,
  SidebarLayoutNavigation,
} from 'layouts/SidebarLayout';

import ErrorMessage from 'components/ErrorMessage';

import LoadingIndicator from 'primitives/LoadingIndicator';

const INVESTMENT_ENTITIES_QUERY_DOCUMENTS = gql(`
  query FetchInvestmentEntities {
    dashboard {
      id
      investmentEntities {
        id
        name
        status
        type
        createdAt
        updatedAt
        statistics {
          numberOfInvestments
        }
      }
    }
  }
`);

const Documents = () => {
  const { loading, error, data, refetch } = useQuery(INVESTMENT_ENTITIES_QUERY_DOCUMENTS);
  const investmentEntities: InvestmentEntityType[] = data?.dashboard.investmentEntities;
  const navigate = useNavigate();

  if (error) return <ErrorMessage error={error} refetch={refetch} />;

  return (
    <SidebarLayout>
      <SidebarLayoutNavigation
        title="Documents"
        subTitle="Access documents by selecting your investment entity"
      />
      <SidebarLayoutContent>
        {loading ? (
          <LoadingIndicator />
        ) : (
          <ul className="divide-y divide-gray-100 overflow-hidden bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl">
            {investmentEntities
              ?.filter(ie => ie.status === 'ACTIVE')
              ?.map(investmentEntity => (
                <InvestmentEntityCard
                  key={investmentEntity.id}
                  id={investmentEntity.id}
                  name={investmentEntity.name}
                  type={investmentEntity.type}
                  status={investmentEntity.status}
                  numberOfInvestments={investmentEntity.statistics.numberOfInvestments}
                  createdAt={investmentEntity.createdAt!}
                  onClick={id => navigate(`/invest/documents/${id}`)}
                />
              ))}
          </ul>
        )}
      </SidebarLayoutContent>
    </SidebarLayout>
  );
};

export default Documents;
